import React, {useState} from 'react';
import classNames from "classnames";
import {SVGFromUrl} from "../../components/media/SVGFromUrl";
import {FaRegImage} from "react-icons/fa";
import {Modal, ModalBody} from "react-bootstrap";


export default function ImageContent({className, style, format, url, alt, hash}) {

    const [showLarge, setShowLarge] = useState(false);

    function mainImageContent() {
        return (
            <div className={"w-100 d-flex justify-content-center clickable image-content rounded"} onClick={() => setShowLarge(true)}>
                {
                    format === "svg" ?
                        <SVGFromUrl
                            url={url}
                            className={className == null ? "" : className}
                            style={style}
                        />

                        :
                        <div>
                            {
                                hash === "PLACEHOLDER" ?
                                    <div
                                        className={"d-flex flex-column align-items-center justify-content-center text-center text-dark bg-light border rounded p-5"}
                                        style={{minHeight: "30vh"}}>
                                        <FaRegImage size={64}/>
                                        <h4>Her mangler det ett bilde</h4>
                                    </div>
                                    :
                                    <img className={className == null ? "w-100 " : className} src={url} style={style}/>
                            }

                            <label>{alt}</label>
                        </div>
                }
            </div>
        );
    }


    if(showLarge) {
        return (
            <Modal className={""}
                   size={"xl"}
                   show={showLarge}
                   onHide={() => setShowLarge(false)}
                   centered={true}
                   onBackdropClick={() => setShowLarge(false)}>
                <ModalBody>
                    {mainImageContent()}

                </ModalBody>
            </Modal>
        );
    }


    return mainImageContent();


}